import React from "react";
import "./navBar.css";
import classNames from "classnames";
import store from "../../store";
import history from "../../history.js";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { refreshToken } from "../../react-cognito/";
import ChangeLogView from "../changeLogView";


import {
  getCurrentUser,
  onReceiveAccessRequest,
  approveAccessRequest,
  rejectAccessRequest,
  fetchAllAccessRequests
} from "../../actions/user";
import { getCurrentPetShop } from "../../actions/petShop";
import { NotificationManager } from "react-notifications";
import classnames from "classnames";
import socket from "../../utils/socket.io";

import moment from "moment";
const $ = window.$;

const userRole = {
  admin :"Admin",
  cashier :"Cashier",
  careTaker :"Caretaker",
  copyWriter:"Copywriter",
  salesPerson:"SalesPerson",
  inspector:"Inspector"
};

class NavBar extends React.Component {
  constructor() {
    super();
  }
  state = {
    user_group: "",
    open: false,
    openMobileMenu: false,
    openMobileUser: false,
    block_ui: false,
    accessRequests: [],
    socketResponse: false,
    socket: socket
  };
  onLogout = event => {
    event.preventDefault();
    // this.state.socket.removeAllListeners();
    // this.state.socket.disconnect();
    if (this.props.user != null) {
      this.props.user.signOut();
      history.replace("/login");
    }
    clearInterval(this.refreshLogin);
  };
  loadFromUrl = () => {
    let split_1 = window.location.hostname.split(".")[0];
    if (split_1 === "192") split_1 = "localhost";
    this.props.getCurrentPetShop(split_1);
  };
  handleDrawerOpen = () => {
    this.props.openSideBar();
    // if(this.props.data.open === true)
    //     this.setState({ open: true });
  };
  activeClass(pathname) {
    let firstPathName = pathname;

    if (history.location.pathname.split("/").length > 2) {
      firstPathName = "/" + history.location.pathname.split("/")[1];

      if (firstPathName === pathname) {
        return "m-menu__item  m-menu__item--submenu m-menu__item--rel m-menu__item--hover";
      } else {
        return "m-menu__item  m-menu__item--submenu m-menu__item--rel";
      }
    } else {
      if (history.location.pathname === pathname) {
        return "m-menu__item  m-menu__item--submenu m-menu__item--rel m-menu__item--hover";
      } else {
        return "m-menu__item  m-menu__item--submenu m-menu__item--rel";
      }
    }
  }
  hashHandler = e => {
    this.setState({ openMobileUser: false });
  };
  toggleTopBar = () => {
    if (!this.state.openMobileUser) {
      this.setState({ openMobileUser: true });
    } else {
      this.setState({ openMobileUser: false });
    }
  };
  toggleMenu = e => {
    this.setState({
      openMobileMenu: !this.state.openMobileMenu,
      block_ui: !this.state.block_ui
    });
  };

  componentDidMount = () => {

    window.addEventListener(
      "hashchange",
      () => {
        this.setState({ openMobileUser: false });
      },
      false
    );
    document.addEventListener("mouseup", this.handleClickOutside);
    var self = this;
    $("#m_header_menu")
      .children()
      .click(function(e) {
        self.setState({ openMobileMenu: false, block_ui: false });
      });

    // if (!this.state.socket.connected) {
    //   this.state.socket.connect();
    // }
    this.refreshLogin(this.props.cognito);
    
  };

  openChangeLogViewModal = () => {
    $("#view_change_log").modal("show");
}

  componentWillMount = () => {
    this.loadFromUrl();
  };
  closeMenu() {
    this.setState({ openMobileMenu: false, block_ui: false });
  }
  componentWillReceiveProps = nextProps => {
    if (
      this.props.currentUser !== nextProps.currentUser &&
      nextProps.currentUser
    ) {
      this.setState({
        user_group: nextProps.currentUser.UserPetstores[0].Role.role_name
      });
      if (nextProps.currentUser.UserPetstores[0].status === "Deactivated") {
        history.push("/login");
        NotificationManager.error(
          "Your account is deactivated. Please contact the admin"
        );
      }
      // if (
      //   nextProps.currentUser.UserPetstores[0].Role.role_name.toLowerCase() ===
      //   "admin"
      // ) {
      //   this.props.fetchAllAccessRequests();
      //   this.state.socket.on(
      //     "access_request_" + nextProps.currentUser.user_sub,
      //     data => {
      //       this.props.onReceiveAccessRequest(data);
      //     }
      //   );
      //   this.state.socket.on(
      //     "pending_access_request_" + nextProps.currentUser.user_sub,
      //     data => {
      //       NotificationManager.info(data.message);
      //     }
      //   );
      // }
    }
    // if (this.props.cognitoState !== nextProps.cognitoState) {
    //   if (nextProps.cognitoState === "SIGNED_OUT") {
    //     this.state.socket.removeAllListeners();
    //     this.state.socket.disconnect();
    //   }
    // }
    if (
      this.props.authStatus !== nextProps.authStatus &&
      nextProps.authStatus === "unAuthorized"
    ) {
      if (this.props.user != null) {
        // this.state.socket.removeAllListeners();
        // this.state.socket.disconnect();
        this.props.user.signOut();
        history.replace("/login");
      }
      NotificationManager.error("Login expired.");
    }
    if (
      nextProps.petShop.currentPetshop !== this.props.petShop.currentPetshop
    ) {
      this.props.getCurrentUser(this.props.user.username);
    }
    // if (this.props.accessRequests !== nextProps.accessRequests) {
    //   this.setState({ accessRequests: nextProps.accessRequests });
    //   if (this.props.accessRequests.length < nextProps.accessRequests.length) {
    //     NotificationManager.success(
    //       `${nextProps.accessRequests.length} New login request(s) received.`
    //     );
    //   }
    // }
  };
  componentWillUpdate(nextProps) {
    if (nextProps.data.open !== this.props.data.open) {
      this.setState(nextProps.data);
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  closeSideBar = () => {
    this.setState({ openMobileMenu: false });
  };
  setWrapperRef = node => {
    this.wrapperRef = node;
  };
  handleClickOutside = e => {
    const menu = $("#m_header_topbar");
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({ openMobileMenu: false });
    }
    if (e.target.id !== "open_top") {
      if (!menu.is(e.target) && menu.has(e.target).length === 0) {
        this.setState({ openMobileUser: false });
      } else {
        if (e.target.tagName.toLowerCase() === "span") {
          this.setState({ openMobileUser: false });
        }
      }
    }
  };
  refreshLogin = state => {
    let _self = this;
    _self.props.refreshToken(state);
    
    setInterval(function() {
      _self.props.refreshToken(state);
    }, 1000 * 60 * 10);
  };
  render() {
    const { open, user_group, accessRequests } = this.state;
    const state = store.getState();
    const isLoggedIn = state.cognito.user !== null;
    const { currentUser, approveLoginRequest, rejectLoginRequest } = this.props;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <header
          className="m-grid__item    m-header "
          data-minimize-offset="200"
          data-minimize-mobile-offset="200"
        >
          {this.state.block_ui ? (
            <div className="block-ui" onClick={() => this.closeMenu()}></div>
          ) : (
            <div></div>
          )}
          <div className="m-container m-container--fluid m-container--full-height">
            <div className="m-stack m-stack--ver m-stack--desktop">
              <div className="m-stack__item m-brand  m-brand--skin-dark">
                <div className="m-stack m-stack--ver m-stack--general">
                  <div className="m-stack__item m-stack__item--middle m-brand__logo">
                    <div className="m-brand__logo-wrapper">
                      <img
                        alt=""
                        src="../../../assets/app/media/img/petpos-white.png"
                        style={{ width: "80px" }}
                      />
                    <div className="user-role">        
                      {user_group}         
                    </div> 
                    </div>
                  </div>
                  <div className="m-stack__item m-stack__item--middle m-brand__tools">
                    <a
                      id="m_aside_header_menu_mobile_toggle"
                      onClick={e => this.toggleMenu(e)}
                      className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block"
                    >
                      <span></span>
                    </a>

                    <a
                      id="m_aside_header_topbar_mobile_toggle"
                      onClick={this.toggleTopBar}
                      className="m-brand__icon m--visible-tablet-and-mobile-inline-block"
                    >
                      
                      <i className={this.props.notifyChangeLog ? "flaticon-bell" : "flaticon-more"} id="open_top">
                          {this.props.notifyChangeLog ?(<span  style={{marginLeft: "-4px" }}>
														<span className="m-badge m-badge--danger notification-badge-mobile" ><span>1</span></span>
													</span>) : null}
                      </i>
                    </a>
                  </div>
                </div>
              </div>

              <div
                className="m-stack__item m-stack__item--fluid m-header-head"
                id="m_header_nav"
              >
                <button
                  onClick={() => this.closeMenu()}
                  className={classnames({
                    "m-aside-header-menu-mobile-close--skin-dark": true,
                    "m-aside-header-menu-mobile-close": !this.state
                      .openMobileMenu,
                    "m-aside-header-menu-mobile-open": this.state.openMobileMenu
                  })}
                >
                  <i className="la la-close"></i>
                </button>
                <div
                  ref={this.setWrapperRef}
                  id="m_header_menu"
                  className={classnames({
                    "m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-light m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-dark m-aside-header-menu-mobile--submenu-skin-dark": true,
                    "m-aside-header-menu-mobile--on": this.state.openMobileMenu
                  })}
                >
                  <ul className="m-menu__nav  m-menu__nav--submenu-arrow ">
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >
                      {  user_group !== userRole.salesPerson ?
                      <NavLink
                        to={`/`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-line-graph"></i>
                        <span className="m-menu__link-text">Dashboard</span>
                      </NavLink>:
                      <NavLink
                        to={`/`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-line-graph"></i>
                        <span className="m-menu__link-text">All Puppies</span>
                      </NavLink>
                      }
                    </li>
                    {  user_group === userRole.salesPerson &&
                    <>
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >                   
                      <NavLink
                        to={`/customers/abandoned-carts`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon la la-opencart"></i> 
                        <span className="m-menu__link-text pl-2">Abandoned Cart</span>
                      </NavLink>              
                    </li>
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >                   
                       <NavLink
                        to={`/subscribe-to-pets/mobileNo`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                       >              
                         <i className="m-menu__link-icon las la-dot-circle"></i>
                         <span className="m-menu__link-text ml-2">
                         <span className="ml-2">Subscribe To Pet</span>
                         </span>
                       </NavLink>           
                    </li>
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >                   
                      <NavLink
                        to={`/quiz`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                       <i className="m-menu__link-icon las la-question"></i> 
                        <span className="m-menu__link-text pl-2">Quiz</span>
                      </NavLink>           
                    </li>
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >                   
                      <NavLink
                        to={`/leads`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon las la-tty"></i> 
                        <span className="m-menu__link-text pl-2">Lead Information</span>
                      </NavLink>            
                    </li>
                                       
                    </>
                    }
                    {user_group !== userRole.copyWriter && user_group !== userRole.inspector && user_group !== userRole.salesPerson ?
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >
                      <NavLink
                        to={`/medical-records`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-edit-1"></i>
                        <span className="m-menu__link-text">
                          Puppy Records
                        </span>
                      </NavLink>
                    </li>:null
                    }
                    {user_group === "Admin" || user_group === "Cashier" ? (
                      <li
                        onClick={this.closeSideBar}
                        className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                        aria-haspopup="true"
                      >
                        <NavLink
                          to={`/contracts`}
                          className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                        >
                          <i className="m-menu__link-icon flaticon-interface-5"></i>
                          <span className="m-menu__link-text">Contracts</span>
                        </NavLink>
                      </li>
                    ) : null}   
                     {user_group !== userRole.copyWriter && user_group !== userRole.inspector && user_group !== userRole.salesPerson ?          
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >
                      <NavLink
                        to={`/treatments/All`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-time-2"></i>
                        <span className="m-menu__link-text">Medicating</span>
                      </NavLink>
                    </li>:null
                    }
                    {user_group !== userRole.copyWriter && user_group !== userRole.inspector && user_group !== userRole.salesPerson ?
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >
                      <NavLink
                        to={`/breeders`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-user-settings"></i>
                        <span className="m-menu__link-text">Breeders</span>
                      </NavLink>
                    </li>:null   
                    }                 
                    {user_group === "Admin" ? (
                    <li
                      onClick={this.closeSideBar}
                      className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                      aria-haspopup="true"
                    >
                      <NavLink
                        to={`/woo-store`}
                        className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                      >
                        <i className="m-menu__link-icon flaticon-refresh"></i>
                        <span className="m-menu__link-text">Task Manager</span>
                      </NavLink>
                    </li>) : null }          
                    {user_group === userRole.admin || user_group === userRole.cashier ? (
                    <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel" aria-haspopup="true">
                      <span className="m-nav__link m-menu__link m-menu__toggle">
                        <i className="m-menu__link-icon las la-caret-down"></i>
                        <span className="m-menu__link-text">More</span>
                        <ul>
                          { user_group === userRole.admin && 
                          <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                            <NavLink
                              to={`/messaging-campaigns`}
                              className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                            >
                              <i className="m-menu__link-icon flaticon-chat mr-2"></i>
                              <span className="m-menu__link-text ml-2">
                                <span className="ml-2">Messaging Campaigns</span>
                              </span>
                            </NavLink>
                          </li>
                           }
                           { user_group === userRole.admin && 
                          <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                            <NavLink
                              to={`/social-media-submission`}
                              className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                            >
                              <i className="m-menu__link-icon fa fa-hashtag mr-2"></i>
                              <span className="m-menu__link-text ml-2">
                                <span className="ml-2">Social Submissions</span>
                              </span>
                            </NavLink>
                          </li>  
                           }
                           { user_group === userRole.admin && 
                          <>
                            <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                              <NavLink
                                to={`/medical-records/vaccines-treatments`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon fa fa-syringe mr-2"></i>
                                <span className="m-menu__link-text ml-2">
                                  <span className="ml-2">Vaccines & Treatments</span>
                                </span>
                              </NavLink>
                            </li> 
                            <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                              <NavLink
                                to={`/location/pages`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i class="m-menu__link-icon lab la-searchengin mr-2"></i>
                                <span className="m-menu__link-text ml-2">
                                  <span className="ml-2">Location Pages</span>
                                </span>
                              </NavLink>
                            </li>                  
                          </>
                           }
                           { user_group === userRole.admin || user_group === userRole.salesPerson ?
                          <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                            <NavLink
                              to={`/subscribe-to-pets/mobileNo`}
                              className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                            >
                              {/* <i className="m-menu__link-icon fa fa-syringe mr-2"></i> */}
                              <i className="m-menu__link-icon las la-dot-circle"></i>
                              <span className="m-menu__link-text ml-2">
                                <span className="ml-2">Subscribe To Pet</span>
                              </span>
                            </NavLink>
                          </li>:null
                            }   
                          { user_group === userRole.admin || user_group === userRole.cashier ? (
                           <li
                              onClick={this.closeSideBar}
                              className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                              aria-haspopup="true"
                            >
                              <NavLink
                                to={`/virtual-visit-requests`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon la la-video-camera"></i> 
                                <span className="m-menu__link-text pl-2">Virtual Visits</span>
                              </NavLink>
                            </li>):null
                          }     
                          {user_group === userRole.admin || user_group === userRole.salesPerson ?  
                           <>
                            <li                           
                                className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                aria-haspopup="true"
                              >
                                <NavLink
                                  to={`/customers/abandoned-carts`}
                                  className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                                >
                                  <i className="m-menu__link-icon la la-opencart"></i> 
                                  <span className="m-menu__link-text pl-2">Abandoned Cart</span>
                                </NavLink>
                            </li>
                            { user_group === userRole.admin && 
                            <li className="m-menu__item  m-menu__item--submenu m-menu__item--rel">
                              <NavLink
                                to={`/breed-sales-dashboard`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon flaticon-imac mr-2"></i>
                                <span className="m-menu__link-text ml-2">
                                  <span className="ml-2">Breed Dashboard</span>
                                </span>
                              </NavLink>
                            </li>
                           }
                            <li                           
                              className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                              aria-haspopup="true"
                            >
                              <NavLink
                                to={`/quiz`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon las la-question"></i> 
                                <span className="m-menu__link-text pl-2">Quiz</span>
                              </NavLink>                       
                            </li>
                            <li                           
                                className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                aria-haspopup="true"
                               >
                              <NavLink
                                to={`/leads`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon las la-tty"></i> 
                                <span className="m-menu__link-text pl-2">Lead Information</span>
                              </NavLink>
                            </li>
                            <li                           
                              className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                              aria-haspopup="true"
                            >
                              <NavLink
                                to={`/customers/loyal-customers`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon la la-heart-o"></i> 
                                <span className="m-menu__link-text pl-2">Loyal Customers</span>
                               </NavLink>
                            </li>
                            <li                           
                              className="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                              aria-haspopup="true"
                            >
                              <NavLink
                                to={`/breeders/applications`}
                                className="m-nav__link m-menu__link m-menu__toggle undeline-nav"
                              >
                                <i className="m-menu__link-icon la la-file-photo-o "></i> 
                                <span className="m-menu__link-text pl-2">Breeders Applications</span>
                               </NavLink>
                            </li>
                           </>:null              
                          }                
                        </ul>
                      </span>
                    </li>): null 
                    }
                  </ul>
                </div>

                <div
                  id="m_header_topbar"
                  className={classNames({
                    "m-topbar  m-stack m-stack--ver m-stack--general": true,
                    "m-topbar-open": this.state.openMobileUser,
                    "m-topbar-close": !this.state.openMobileUser
                  })}
                >
                  <div className="m-stack__item m-topbar__nav-wrapper">
                    <ul className="m-topbar__nav m-nav m-nav--inline">
                      {currentUser && user_group !== userRole.copyWriter && (
                        <li
                          className="m-nav__item 
                          m-topbar__notifications 
                          m-topbar__notifications--img 
                          m-dropdown m-dropdown--large 
                          m-dropdown--align-right
                          m-dropdown--header-bg-fill 
                          m-dropdown--arrow  	
                          m-dropdown--mobile-full-width"
                          data-dropdown-toggle="click"
                          data-dropdown-persistent="1"
                        >
                          <a
                            href="#"
                            className="m-nav__link m-dropdown__toggle"
                            id=""
                          >
                            {accessRequests.length > 0 && (
                              <span className="m-nav__link-badge m-badge m-badge--dot m-badge--dot-large m-badge--danger"></span>
                            )}
                            <span className="m-nav__link-icon">
                              <i className="flaticon-music-2"></i>
                            </span>
                          </a>
                          <div className="m-dropdown__wrapper">
                            <span className="m-dropdown__arrow m-dropdown__arrow--right"></span>
                            <div className="m-dropdown__inner">
                              <div
                                className="m-dropdown__header m--align-center"
                                style={{ backgroundColor: "rgb(40, 42, 60)" }}
                              >
                                <span className="m-dropdown__header-title">
                                  {accessRequests.length} New
                                </span>
                                <span className="m-dropdown__header-subtitle">
                                  User Notifications
                                </span>
                              </div>
                              <div className="m-dropdown__body px-0">
                                <div className="m-dropdown__content">
                                  <ul
                                    className="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand mx-4"
                                    role="tablist"
                                  >
                                    {user_group === "Admin" && (
                                      <li className="nav-item m-tabs__item">
                                        <a
                                          className="nav-link m-tabs__link active"
                                          data-toggle="tab"
                                          href="#login_requests_notifications"
                                          role="tab"
                                        >
                                          Login Requests
                                        </a>
                                      </li>
                                    )}

                                    {/* <li className="nav-item m-tabs__item">
                                      <a
                                        className="nav-link m-tabs__link"
                                        data-toggle="tab"
                                        href="#topbar_notifications_events"
                                        role="tab"
                                      >
                                        Events
                                      </a>
                                    </li>
                                    <li className="nav-item m-tabs__item">
                                      <a
                                        className="nav-link m-tabs__link"
                                        data-toggle="tab"
                                        href="#topbar_notifications_logs"
                                        role="tab"
                                      >
                                        Logs
                                      </a>
                                    </li> */}
                                  </ul>
                                  <div className="tab-content">
                                    <PerfectScrollbar
                                      style={{ maxHeight: "360px" }}
                                    >
                                      {user_group === "Admin" && (
                                        <div
                                          className="tab-pane active"
                                          id="login_requests_notifications"
                                          role="tabpanel"
                                        >
                                          <div className="m-widget4">
                                            {/* {accessRequests.map(
                                              (item, index) => (
                                                <div
                                                  className="m-widget4__item mx-4"
                                                  key={index}
                                                >
                                                 { item.User
                                                         ? 
                                                  <div>       
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                      {!item.User.UserPetstores[0]
                                                        .avatar_file_name ? (
                                                        item.User.UserPetstores[0]
                                                          .gender === "male" ? (
                                                          <img
                                                            src="../assets/app/media/img/users/men_sample.png"
                                                            className="m--img-rounded m--marginless"
                                                            style={{
                                                              width: "5rem"
                                                            }}
                                                            alt=""
                                                          />
                                                        ) : (
                                                          <img
                                                            src="../assets/app/media/img/users/women_sample.png"
                                                            className="m--img-rounded m--marginless"
                                                            style={{
                                                              width: "5rem"
                                                            }}
                                                            alt=""
                                                          />
                                                        )
                                                      ) : (
                                                        <img
                                                          src={
                                                            process.env.REACT_APP_S3_PATH +
                                                            "/" +
                                                            item.User
                                                              .UserPetstores[0]
                                                              .avatar_path +
                                                            "/" +
                                                            item.User
                                                              .UserPetstores[0]
                                                              .avatar_file_name
                                                          }
                                                          className="m--img-rounded m--marginless"
                                                          style={{
                                                            width: "5rem"
                                                          }}
                                                          alt=""
                                                        />
                                                      )}
                                                    </div>
                                                  
                                                    <div className="m-widget4__info">
                                                      <span className="m-widget4__title">
                                                        {
                                                          item.User
                                                            .UserPetstores[0]
                                                            .firstname
                                                        }{" "}
                                                        {
                                                          item.User
                                                            .UserPetstores[0]
                                                            .lastname
                                                        }{" "}
                                                      </span>
                                                      <br />
                                                      <span className="m-widget4__sub">
                                                        {
                                                          item.User
                                                            .UserPetstores[0].Role
                                                            .role_name
                                                        }
                                                        <br />
                                                        <small>
                                                          {moment(
                                                            item.createdAt
                                                          ).fromNow()}
                                                        </small>
                                                      </span>
                                                    </div>
                                                 
                                                  </div>
                                                  : null }   
                                                          
                                                  <div className="m-widget4__ext">
                                                    <a
                                                      href="#"
                                                      className="m-btn m-btn--pill btn-sm btn btn-outline-success"
                                                      onClick={e =>
                                                        approveLoginRequest(
                                                          e,
                                                          item
                                                        )
                                                      }
                                                    >
                                                      Approve
                                                    </a>
                                                    <a
                                                      href="#"
                                                      className="m-btn m-btn--pill btn btn-sm btn-outline-danger"
                                                      onClick={e =>
                                                        rejectLoginRequest(
                                                          e,
                                                          item
                                                        )
                                                      }
                                                    >
                                                      Reject
                                                    </a>
                                                  </div>
                                                </div>
                                              )
                                            )} */}
                                          </div>
                                        </div>
                                      )}
                                    </PerfectScrollbar>
                                    {/* <div
                                      className="tab-pane"
                                      id="topbar_notifications_events"
                                      role="tabpanel"
                                    >
                                      <div
                                        className="m-scrollable"
                                        data-scrollable="true"
                                        data-height="250"
                                        data-mobile-height="200"
                                      >
                                        <div className="m-list-timeline m-list-timeline--skin-light">
                                          <div className="m-list-timeline__items">
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-success"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                New order received
                                              </a>
                                              <span className="m-list-timeline__time">
                                                Just now
                                              </span>
                                            </div>
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-danger"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                New invoice received
                                              </a>
                                              <span className="m-list-timeline__time">
                                                20 mins
                                              </span>
                                            </div>
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-success"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                Production server up
                                              </a>
                                              <span className="m-list-timeline__time">
                                                5 hrs
                                              </span>
                                            </div>
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-info"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                New order received
                                              </a>
                                              <span className="m-list-timeline__time">
                                                7 hrs
                                              </span>
                                            </div>
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-info"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                System shutdown
                                              </a>
                                              <span className="m-list-timeline__time">
                                                11 mins
                                              </span>
                                            </div>
                                            <div className="m-list-timeline__item">
                                              <span className="m-list-timeline__badge m-list-timeline__badge--state1-info"></span>
                                              <a
                                                href=""
                                                className="m-list-timeline__text"
                                              >
                                                Production server down
                                              </a>
                                              <span className="m-list-timeline__time">
                                                3 hrs
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane"
                                      id="topbar_notifications_logs"
                                      role="tabpanel"
                                    >
                                      <div className="m-stack m-stack--ver m-stack--general">
                                        <div className="m-stack__item m-stack__item--center m-stack__item--middle">
                                          <span className="">
                                            All caught up!
                                            <br />
                                            No new logs.
                                          </span>
                                        </div>
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}

                      {currentUser && (
                        <li

                          className="
                          m-nav__item 
                          m-topbar__user-profile 
                          m-topbar__user-profile--img 
                          m-dropdown m-dropdown--medium 
                          m-dropdown--arrow 
                          m-dropdown--header-bg-fill 
                          m-dropdown--align-right 
                          m-dropdown--mobile-full-width 
                          m-dropdown--skin-light"
                          data-dropdown-toggle="click"
                        >
                          <a
                            href="#"
                            className="m-nav__link m-dropdown__toggle"
                          >
                            {this.props.notifyChangeLog && user_group !== userRole.copyWriter ?(<span className="m-nav__link-badge" style={{marginLeft: "10px" , top : "1px"}}>
																<span className="m-badge m-badge--danger notification-badge-size"></span>
														</span>) : null}
                            
                            <span className="m-topbar__userpic">
                              {!currentUser.UserPetstores[0]
                                .avatar_file_name ? (
                                currentUser.UserPetstores[0].gender ===
                                "male" ? (
                                  <img
                                    src="../assets/app/media/img/users/men_sample.png"
                                    className="m--img-rounded m--marginless"
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    src="../assets/app/media/img/users/women_sample.png"
                                    className="m--img-rounded m--marginless"
                                    alt=""
                                  />
                                )
                              ) : (
                                <img
                                  src={
                                    process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    currentUser.UserPetstores[0].avatar_path +
                                    "/" +
                                    currentUser.UserPetstores[0]
                                      .avatar_file_name
                                  }
                                  className="m--img-rounded m--marginless m--img-centered"
                                  alt=""
                                />
                              )}
                            </span>
                            <span className="m-topbar__username m--hide">
                              {currentUser.email}
                            </span>
                          </a>
                          <div className="m-dropdown__wrapper">
                            <span className="m-dropdown__arrow m-dropdown__arrow--right"></span>
                            <div className="m-dropdown__inner">
                              <div
                                className="m-dropdown__header m--align-center"
                                style={{ backgroundColor: "#282a3c" }}
                              >
                                <div className="m-card-user m-card-user--skin-dark">
                                  <div className="m-card-user__pic">
                                    {!currentUser.UserPetstores[0]
                                      .avatar_file_name ? (
                                      currentUser.UserPetstores[0].gender ===
                                      "male" ? (
                                        <img
                                          src="../assets/app/media/img/users/men_sample.png"
                                          className="m--img-rounded m--marginless"
                                          alt=""
                                        />
                                      ) : (
                                        <img
                                          src="../assets/app/media/img/users/women_sample.png"
                                          className="m--img-rounded m--marginless"
                                          alt=""
                                        />
                                      )
                                    ) : (
                                      <img
                                        src={
                                          process.env.REACT_APP_S3_PATH +
                                          "/" +
                                          currentUser.UserPetstores[0]
                                            .avatar_path +
                                          "/" +
                                          currentUser.UserPetstores[0]
                                            .avatar_file_name
                                        }
                                        className="m--img-rounded m--marginless"
                                        alt=""
                                      />
                                    )}
                                  </div>
                                  <div className="m-card-user__details">
                                    <span className="m-card-user__name m--font-weight-500">
                                      {currentUser.UserPetstores[0].firstname}{" "}
                                      {currentUser.UserPetstores[0].lastname}
                                    </span>
                                    <span className="m-card-user__email m--font-weight-300 m-link">
                                      {currentUser.email}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="m-dropdown__body">
                                <div className="m-dropdown__content">
                                  <ul className="m-nav m-nav--skin-light">
                                    <li className="m-nav__section m--hide">
                                      <span className="m-nav__section-text">
                                        Section
                                      </span>
                                    </li>
                                    {user_group !== userRole.copyWriter && user_group !== userRole.inspector && user_group !== userRole.salesPerson ?
                                      <li className="m-nav__item">
                                        <NavLink
                                          to={`/settings`}
                                          className="m-nav__link"
                                        >
                                          <i className="m-nav__link-icon flaticon-settings-1"></i>
                                          <span className="m-nav__link-title">
                                            <span className="m-nav__link-wrap">
                                              <span className="m-nav__link-text">
                                                Settings
                                              </span>
                                            </span>
                                          </span>
                                        </NavLink>
                                      </li>:null
                                    }                       
                                    {user_group !== userRole.copyWriter && user_group !== userRole.inspector  && user_group !== userRole.salesPerson ?
                                    <li className="m-nav__item">
                                      <NavLink
                                        to={`/users/${currentUser.id}`}
                                        className="m-nav__link"
                                      >
                                        <i className="m-nav__link-icon flaticon-avatar"></i>
                                        <span className="m-nav__link-title">
                                          <span className="m-nav__link-wrap">
                                            <span className="m-nav__link-text">
                                              My Profile
                                            </span>
                                          </span>
                                        </span>
                                      </NavLink>
                                    </li>:null
                                    }
                                    {user_group !== userRole.copyWriter && user_group !== userRole.inspector && user_group !== userRole.salesPerson ?
                                    <li className="m-nav__item">
                                        <a href="#"  onClick={() => this.openChangeLogViewModal()}                             
                                          className="m-nav__link"
                                        >
                                          <i className="m-nav__link-icon flaticon-notes"></i> 
                                          <span className="m-nav__link-title">
                                          
                                            <span className="m-nav__link-wrap">
                                            
                                              <span className="m-nav__link-text">
                                               What's New 
                                              </span>
                                              {this.props.notifyChangeLog ? (<span className="m-nav__link-badge">
																					      <span className="m-badge m-badge--danger notification-badge-size"></span>
																				      </span>) : null}                                           
                                            </span>
                                          </span>
                                        </a>
                                    </li>:null
                                   }
                                    <li className="m-nav__separator m-nav__separator--fit"></li>
                                    <li
                                      className="m-nav__item"
                                      onClick={e => this.onLogout(e)}
                                    >
                                      <a
                                        href="../../../snippets/pages/user/login-1.html"
                                        className="btn m-btn--pill    btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                                      >
                                        Logout
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
       <ChangeLogView/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.cognito.user,
    cognitoState: state.cognito.state,
    petShop: state.petShopReducer,
    cacheUser: state.cacheUser,
    currentUser: state.userReducer.currentUser,
    authStatus: state.navBarReducer.authStatus,
    accessRequests: state.userReducer.accessRequests,
    cognito: state.cognito,
    notifyChangeLog: state.changeLogReducer.notifyChangeLog,
  };
};

const mapDispatchToProps = dispatch => ({
  getCurrentUser: un => {
    dispatch(getCurrentUser(un));
  },
  getCurrentPetShop: t => {
    dispatch(getCurrentPetShop(t));
  },
  approveLoginRequest: (e, ar) => {
    e.preventDefault();
    dispatch(approveAccessRequest(ar));
  },
  rejectLoginRequest: (e, rr) => {
    e.preventDefault();
    dispatch(rejectAccessRequest(rr));
  },
  fetchAllAccessRequests: () => {
    dispatch(fetchAllAccessRequests());
  },
  onReceiveAccessRequest: data => {
    dispatch(onReceiveAccessRequest(data));
  },
  refreshToken: state =>
    refreshToken(state.user.username, state.userPool, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
